import { ApiService } from '@/services/api.service'

export const City = {
  async getCityConfig () {
    const response = await ApiService.get('cities/')
    return response.data.data[0].attributes
  }
}
